import {
  InfoIcon,
  LeftArrowIcon,
  SendMoneyIcon,
  TimingIcon,
} from "@dataone/icons";
import { ILatestSearchResponse } from "@dataone/lib";
import { Button } from "antd";
import { styled } from "styled-components";

interface DatabaseSessionProps {
  latestSearch?: ILatestSearchResponse;
  dataSourceloading?: boolean;
  handleContinueSession: (searchId?: string) => void;
}

const DatabaseSession = ({
  latestSearch,
  dataSourceloading,
  handleContinueSession,
}: DatabaseSessionProps) => {
  return (
    <>
      <StyledDatabaseSession>
        <TimingIcon />
        <p>
          Would you like to continue your previous search{" "}
          {latestSearch?.displayName ? (
            <>
              <strong>{latestSearch.displayName}</strong> data source
            </>
          ) : (
            "or begin a new one"
          )}
          ?{/* <InfoIcon /> */}
        </p>
        {latestSearch ? (
          <StyledButton
            onClick={() => handleContinueSession(latestSearch.id)}
            disabled={!dataSourceloading ? true : false}
          >
            <StyledLeftArrowIcon>
              <LeftArrowIcon />
            </StyledLeftArrowIcon>
            <div className="reset">
              {dataSourceloading ? "Continue" : "Continuing ..."}
            </div>
          </StyledButton>
        ) : (
          <StyledButton
            onClick={() => handleContinueSession()}
            disabled={!dataSourceloading ? true : false}
          >
            <StyledLeftArrowIcon>
              <LeftArrowIcon />
            </StyledLeftArrowIcon>
            <div className="reset">
              {dataSourceloading ? "Continue" : "Continuing ..."}
            </div>
          </StyledButton>
        )}
      </StyledDatabaseSession>
    </>
  );
};

export default DatabaseSession;

const StyledDatabaseSession = styled.div`
  // background: #eff1fd;
  padding: 5px 10px;
  border-radius: 8px;
  display: flex;
  font-size: 12px;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  gap: 10px;
  p {
    flex: 1;
    svg {
      margin-right: 10px;
      margin-left: 5px;
    }
  }
`;
const StyledLeftArrowIcon = styled.div`
  display: flex;
  font-size: 25px;
  color: #4974f6;
  border: 1.5px solid #4974f6;
  border-radius: 20px;
  margin-right: 5px;
  position: absolute;
  width: 28px;
  transition: width 0.5s ease-in-out;
  svg {
    transform: rotate(180deg);
  }
`;

const StyledButton = styled.div<{ disabled: boolean }>`
  margin-left: auto;
  font-size: 14px;
  display: flex;
  align-items: center;
  border-radius: 20px;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  width: 126px;
  position: relative;
  ${StyledLeftArrowIcon} {
    transition: width 0.5s ease-in-out;
  }
  &:hover {
    ${StyledLeftArrowIcon} {
      width: 135px;
    }
  }
  ${({ disabled }) =>
    disabled &&
    `
    ${StyledLeftArrowIcon} {
      width: 135px;
    }
  `}
  .reset {
    line-height: 1px;
    margin-left: ${({ disabled }) => (disabled ? "33px" : "42px")};
  }
`;
